import axiosInstance from "../../utils/axiosInstance";

const caseStudyService = {

    /* =====================================================
       PUBLIC - GET CASE STUDIES
    ====================================================== */

    getPublicCaseStudies: async (
        page = 1,
        pageSize = 10
    ) => {

        const response = await axiosInstance.get(
            "/CaseStudies",
            {
                params: {
                    page,
                    pageSize
                }
            }
        );

        return response.data;
    },


    /* =====================================================
       PUBLIC - GET CASE STUDY BY ID
    ====================================================== */

    getPublicCaseStudyById: async (id) => {

        const response = await axiosInstance.get(
            `/CaseStudies/${id}`
        );

        return response.data;
    },


    /* =====================================================
       ADMIN - GET LIST
    ====================================================== */

    getList: async (
        page = 1,
        pageSize = 10,
        search = ""
    ) => {

        const response = await axiosInstance.get(
            "/CaseStudies",
            {
                params: {
                    page,
                    pageSize,
                    search
                }
            }
        );

        return response.data;
    },


    /* =====================================================
       ADMIN - GET BY ID
    ====================================================== */

    getById: async (id) => {

        const response = await axiosInstance.get(
            `/CaseStudies/${id}`
        );

        return response.data;
    },


    /* =====================================================
       CREATE
    ====================================================== */

    create: async (data) => {

        const response = await axiosInstance.post(
            "/CaseStudies",
            data
        );

        return response.data;
    },


    /* =====================================================
       UPDATE
    ====================================================== */

    update: async (id, data) => {

        const response = await axiosInstance.put(
            `/CaseStudies/${id}`,
            data
        );

        return response.data;
    },


    /* =====================================================
       DELETE
    ====================================================== */

    delete: async (id) => {

        const response = await axiosInstance.delete(
            `/CaseStudies/${id}`
        );

        return response.data;
    }

};

export default caseStudyService;

